import { v4 as uuid } from 'uuid';

// Keep the same key after an uncertain response; a new input or acknowledged
// submission gets a new key. Other report producers keep their existing flow.
export const archiveRequest = (payload, previous) => {
	if (Number(payload.reportId) !== 10) return { request: { data: payload }, pending: null };
	const signature = JSON.stringify(payload);
	const pending = previous?.signature === signature ? previous : { signature, key: uuid() };
	return { request: { data: payload, headers: { 'Idempotency-Key': pending.key } }, pending };
};
